import { render, staticRenderFns } from "./GlobalPositionByCategory.vue?vue&type=template&id=424fcb2b&"
import script from "./GlobalPositionByCategory.vue?vue&type=script&lang=js&"
export * from "./GlobalPositionByCategory.vue?vue&type=script&lang=js&"
import style0 from "./GlobalPositionByCategory.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports